
import { Options, Vue } from "vue-class-component";
import MenuSet from "@/services/localstorage/MenuLocal"
import { Watch } from "vue-property-decorator";
import {userModule} from '@/store/module/UserStore'
import {PermGet, PermSet} from "@/services/localstorage/UserLocal"
import router from "@/router";
@Options({
  props: {
    prop: String,
  },
  
   
})
export default class NavBar extends Vue {
  
  @Watch('prop')
  OnPropertyChanged(value:string, oldValue:string)
  {
    if(value==null)
    {
    this.username=null
    }
    else
    {
          this.username=MenuSet()
          this.dropdowns=PermGet()
  console.log(this.username, this.dropdowns)
    }
  }
  
  username=MenuSet()
  dropdowns=PermGet()
  LogOut()
  {
    localStorage.clear()
    this.username=null
        router.push("/")

  }
}
